import { useEffect, useRef, useState } from 'react';
import { Portal } from '@aviv-estimation-funnel/estimation-data-models/enums';
import lazyLoad from '@aviv-estimation-funnel/shells/src/app/helpers/lazyLoad';
import { CSSObject, Global } from '@emotion/react';
import { Box, useTokens } from '@gemini/core';
import { useAppContext } from '@mfe-presentation/contexts';

const AgentsListModule = lazyLoad(async () => import('AgentsList/Module'));

const agentsListContainerStyles = (): CSSObject => ({
    '#agents_list_mfe > div': {
        width: '100%',
    },
});

export interface IAgentsListProps {
    email: string;
    ownerObjective?: string;
    estimationAgentsCorrelationId: string;
    zip?: string;
    sellPrice: number;
    previousEstimationId?: string;
    designToken?: Record<string, any>;
}

const AgentsList = ({ agentsListProps }: { agentsListProps: IAgentsListProps }) => {
    const [designToken, setDesignToken] = useState<Record<string, any>>();
    const { portal } = useAppContext();
    const tokens = useTokens();

    const agentsListRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        import(/* webpackChunkName: "parcels-ui-tokens"*/ '@parcels-ui/tokens').then(
            ({ IWTTokens, IMNTokens }) => {
                setDesignToken(portal === Portal.ImmoWelt ? IWTTokens : IMNTokens);
            },
        );
    }, [portal]);

    return (
        <Box
            ref={agentsListRef}
            unsafe_className="card-container card-container--first"
            width="100%"
            minWidth={{
                'breakpoint.base': 0,
                'breakpoint.md': `calc((780px - ${tokens['spacing.32']} - ${tokens['spacing.32']} - ${tokens['spacing.24']}) / 2)`,
            }}
        >
            <Global styles={() => agentsListContainerStyles()} />
            <AgentsListModule state={{ ...agentsListProps, designToken }} />
        </Box>
    );
};

export default AgentsList;
